export const Z_INDEX_NO_DATA = 1

export const Z_INDEX_ON = 2

export const Z_INDEX_OFF = 0

export const MILLISECONDS_IN_HOUR = 3_600_000

export const Z_INDEX_NOT_APPLICABLE = -1

export const Z_INDEX_HAS_DATA = 2

export const STATUS_VALUE_TYPE = 'irrigationIsOn_status'

export const IRRIGATION_ZONE_ACTIVITY_PUBLISHED_EVENT_DURATION_VALUE_TYPE_PREFIX =
  'irrigationActivity_currentPublishedEventDurationSum_' as const

export const IRRIGATION_ZONE_ACTIVITY_APPLIED_EVENT_DURATION_VALUE_TYPE_PREFIX =
  'irrigationActivity_currentAppliedEventDurationSum_' as const

export const PRESSURE_VALUE_TYPE = 'irrigationActivity_currentPressure_psi'

export const CURRENT_PRESSURE_VALUE_TYPE_PREFIX = 'irrigationActivity_currentPressure_' as const

export const CURRENT_PRESSURE_VALUE_TYPE_SUFFIX = '_psi' as const

export const PRESSURE_STALE_AFTER_MS = 45 * 60 * 1000

export const MAX_PLAUSIBLE_PRESSURE_PSI = 200

export const Z_INDEX_PRESSURE_NONE = 0

export const Z_INDEX_PRESSURE_STALE = 1

export const Z_INDEX_PRESSURE_LIVE = 2

export const Z_INDEX_PRESSURE_RUNNING = 3
